import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IVoucherType } from "src/models/Prices/Voucher.models";

interface VoucherTypeState {
  vouchersType: IVoucherType[];
  voucherTypeToEdit: IVoucherType | null;
}

const initialState: VoucherTypeState = {
  vouchersType: [],
  voucherTypeToEdit: null,
};

const VoucherTypeSlice = createSlice({
  name: "VoucherType",
  initialState,
  reducers: {
    setVoucherTypeList: (state, action: PayloadAction<IVoucherType[]>) => {
      state.vouchersType = action.payload;
    },
    setVoucherTypeToEdit: (
      state,
      action: PayloadAction<IVoucherType | null>
    ) => {
      state.voucherTypeToEdit = action.payload;
    },
    concatListVoucherType: (
      state: VoucherTypeState,
      action: PayloadAction<IVoucherType[]>
    ) => {
      state.vouchersType = [...state.vouchersType.concat(action.payload)];
    },
    addVoucherType: (state, action: PayloadAction<IVoucherType>) => {
      state.vouchersType.push(action.payload);
    },
    updateVoucherType: (state, action: PayloadAction<IVoucherType>) => {
      let itemIndex = state.vouchersType.findIndex(
        item => item.voucherTypeId === action.payload.voucherTypeId
      );
      if (itemIndex !== -1) state.vouchersType[itemIndex] = action.payload;
    },
    deleteVoucherType: (state, action: PayloadAction<number>) => {
      const newArray = state.vouchersType.filter(
        item => item.voucherTypeId !== action.payload
      );
      state.vouchersType = newArray;
    },
  },
});

export const {
  setVoucherTypeList,
  concatListVoucherType,
  setVoucherTypeToEdit,
  addVoucherType,
  updateVoucherType,
  deleteVoucherType,
} = VoucherTypeSlice.actions;

export default VoucherTypeSlice.reducer;
